import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { CONFIGURATION_FEATURE, configurationReducer } from './store/configuration.reducer';
import { ConfigurationService } from './store/configuration.service';
import { ConfigurationComponent } from './configuration/configuration.component';
import { AsyncPipe, CommonModule, NgTemplateOutlet } from '@angular/common';
import { DeploymentPipesModule } from '../deployments/pipes/deployment-pipes.module';
import { NgbAlert, NgbCollapse, NgbModule, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import {
  ConfigurationHierarchyListComponent
} from './configuration-hierarchy-list/configuration-hierarchy-list.component';
import { FormsModule } from '@angular/forms';
import { CdkFixedSizeVirtualScroll, CdkVirtualForOf, CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { ConfigurationOfficesListComponent } from './configuration-offices-list/configuration-offices-list.component';
import { EffectsModule } from '@ngrx/effects';
import { ConfigurationEffects } from './store/configuration.effects';
import { ConfigurationsPipesModule } from './pipes/configurations-pipe.module';
import { InventoryPanelsModule } from '../inventory-panels/inventory-panels.module';
import { EditConfigurationComponent } from './edit-configuration/edit-configuration.component';
import { AccordionModule } from '../shared/list/details/accordion/accordion.module';
import { PipesModule } from '../shared/pipes/pipes.module';
import { PermissionsModule } from '../user/permissions/permissions.module';
import { ActivationParametersModule } from '../activation-parameters/activation-parameters.module';

/**
 * Components of Configuration module
 */
@NgModule({
  imports: [
    StoreModule.forFeature(CONFIGURATION_FEATURE, configurationReducer),
    EffectsModule.forFeature([ConfigurationEffects]),
    DeploymentPipesModule,
    ConfigurationsPipesModule,
    InventoryPanelsModule,
    AsyncPipe,
    NgbTooltip,
    NgbCollapse,
    NgTemplateOutlet,
    FormsModule,
    CdkVirtualScrollViewport,
    CdkFixedSizeVirtualScroll,
    CdkVirtualForOf,
    NgbAlert,
    CommonModule,
    NgbModule,
    AccordionModule,
    PipesModule,
    PermissionsModule,
    ActivationParametersModule,
  ],
  providers: [
    ConfigurationService
  ],
  declarations: [
    ConfigurationComponent,
    ConfigurationHierarchyListComponent,
    ConfigurationOfficesListComponent,
    EditConfigurationComponent,
  ],
  exports: [
    ConfigurationComponent
  ]
})
export class ConfigurationModule {
}
